<script>
import {mergeData} from 'vue-functional-data-merge'
import {format} from '../../utils/format'
import {getContextInjections} from '../../utils/vm'

export default {
  name: 'Formatter',
  inject: {
    ...getContextInjections()
  },
  props: {
    type: {
      type: String
    },
    value: {
      type: null
    },
    locale: {
      type: String
    },
    currency: {
      type: String
    },
    timezone: {
      type: String
    },
    inputTimezone: {
      type: String
    }
  },
  functional: true,
  render(h, {data, injections, props, $style}) {
    const {type, value} = props
    const context = type && {
      type,
      locale: props.locale || injections.defaultLocale,
      currency: props.currency || injections.defaultCurrency,
      timezone: props.timezone || injections.defaultTimezone,
      inputTimezone: props.inputTimezone || injections.defaultInputTimezone
    }
    let title
    if (type && type.indexOf('date') >= 0) {
      title = format(value, 'dateIso', context)
    }
    const result = format(value, type, context)
    return h('span', mergeData(data, {
      class: [
        'UIElement',
        $style.Formatter
      ],
      attrs: {
        title
      }
    }), [result])
  }
}
</script>

<style lang="scss" module>
.Formatter {
  font-size: inherit;
}
</style>
